/* globals IntersectionObserver */

const navigation = document.querySelector('.js-navigation')

/**
 * Add or remove `is-sticky` class depending on
 * CSS `position: sticky` state
 */
if (navigation && global.IntersectionObserver) {
  // Create sentinel element as an event trigger
  const sentinel = document.createElement('div')
  // Hide sentinel for screenreaders
  sentinel.setAttribute('aria-hidden', 'true')
  // Give it some height for Edge
  sentinel.style.height = '1px'
  // Insert sentinel right before navigation
  navigation.parentNode.insertBefore(sentinel, navigation)

  const observer = new IntersectionObserver(entries => {
    const targetBounding = entries[0].boundingClientRect
    const rootBounds = entries[0].rootBounds

    if (targetBounding.bottom < rootBounds.top) {
      navigation.classList.add('is-sticky')
    }

    if (
      targetBounding.bottom >= rootBounds.top &&
      targetBounding.bottom < rootBounds.bottom
    ) {
      navigation.classList.remove('is-sticky')
    }
  })

  observer.observe(sentinel)
}



// WEBPACK FOOTER //
// ./src/components/navigation/icon.js